import React, { useEffect, useState } from 'react'
// @mui
import { Button, Card, Checkbox, Container, IconButton, MenuItem, Popover, Stack, Table, TableContainer, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography, Tooltip } from '@mui/material'
import { Add as AddIcon } from '@mui/icons-material'
// components
import Iconify from '../../common/common-sidebar/components/iconify';
import { Helmet } from 'react-helmet-async'
import { Link as RouterLink } from 'react-router-dom';
import loader from '../../images/loader.gif';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from 'react-toastify';
import { BaseURL } from '../../common/URLs';
import { useNavigate } from "react-router-dom";
import { getLocalStorageItem } from '../../common/localStorageUtils';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbarContainer, GridToolbarQuickFilter, GridToolbar, GridToolbarExport } from '@mui/x-data-grid';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { HELPDESK_ROLES } from '../../common/constants';
import { loaderService } from '../../common/custom-loader/loader-service';
import { EditIcon } from '../../common/icons';
import apiClient from '../../axios';


function ManageCategoryPage() {
  const auth = 'Bearer ' + getLocalStorageItem('id_token');
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(null);
  const [userdetails, setUserdetails] = useState([]);
  const [managesladata, setmanagesladata] = useState([])
  const rows = [...managesladata];
  const filteredData = managesladata.filter(item => item.extFlag === 1);
  const extrows = [...filteredData]
  // const [isLoading, setLoading] = useState(true);
  const [openId, setOpenId] = useState(null);
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalClose = () => setLogModalOpen(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const [selectedId, setSelectedId] = useState();

  const issueColumns = [

    { field: 'grievanceCategory', headerName: 'Service Request Main Category', width: 150 },
    { field: 'grievanceSubCategory', headerName: 'Service Request Sub Category', width: 150 },
    { field: 'slaDuration', headerName: 'SLA 1(Hrs)', width: 80 },
    { field: 'sla1authority', headerName: 'SLA 1 Escalation Authority', minWidth: 150, flex: 1 },
    { field: 'sla2Duration', headerName: 'SLA 2(Hrs)', width: 80 },
    { field: 'sla2authority', headerName: 'SLA 2 Escalation Authority', minWidth: 150, flex: 1 },
    { field: 'sla3Duration', headerName: 'SLA 3(Hrs)', width: 80 },
    { field: 'sla3authority', headerName: 'SLA 3 Escalation Authority', width: 150 },
    {
      field: 'action', headerName: 'Action',
      renderCell: (params) => {
        return (
          <>
            <Tooltip title="Edit">
              <IconButton color='primary' onClick={() => { navigate(`ManageSLAedit/${params?.row?.id}`) }}>
                <EditIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Remove">
              <IconButton size='small' onClick={(e) => deletefaq(params?.row?.id)} color="error">
                <DeleteIcon />
              </IconButton>
            </Tooltip>
            {/* <IconButton size="large" color="inherit" onClick={(e) =>
              handleOpenMenu(e, params?.row?.id)}>
              <Iconify icon={'eva:more-vertical-fill'} />
            </IconButton> */}
          </>
        )
      }
    }



  ]


  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenMenu = (event, id) => {
    setOpen(event.currentTarget);
    setOpenId(id)
  };
  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId('')
  };

  useEffect(() => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/getUserDetails",
      {},
      {
        headers: {
          Authorization: "Bearer " + getLocalStorageItem('id_token')
        }
      }
    ).then((response) => {
      setUserdetails([response.data?.categoryName, response.data?.name, response.data?.usertype]);
      loaderService.hideLoader();
    }).
      catch((error) => {
        console.log("error-- ", error)
        loaderService.hideLoader();
      })
  }, [])


  useEffect(() => {
    managefaqsla()
  }, [])


  const managefaqsla = () => {
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/fetchAllSlaWithCategory",

      {

      },

      {
        headers: {
          "Authorization": auth
        },
      }
    ).then((response) => {
      if (localStorage.getItem('role') === HELPDESK_ROLES.ExternalAdminUser) {
        let data = response.data.filter(item => item.extFlag === 1);
        setmanagesladata(data)
      }
      else {
        let data = response.data.filter(item => item.extFlag === 0);
        setmanagesladata(data)
      }
      // setmanagesladata(response.data);
      // setLoading(false)
      // console.log(respData, "responseData");
      loaderService.hideLoader();
    }).catch((error) => {
      console.log("Error - " + error);
      loaderService.hideLoader();
    })
  }

  const onConfirmDelete = () => {
    handleLogModalClose();
    loaderService.showLoader();
    apiClient.post(
      BaseURL + "/grievanceandhelpdesk/v1/helpdesk/deleteSlaMasterById",

      {
        "id": selectedId,

      },

      {
        headers: {
          "Authorization": auth
        },
      }
    ).then((response) => {
      // console.log("delete - ", response);
      response.data.status === "SUCCESS" ? toast.success(response.data.description) : toast.error(response.data.description)
      managefaqsla();
      loaderService.hideLoader();
    }).catch((error) => {
      console.log("Error - " + error);
      loaderService.hideLoader();
    })
  }

  const deletefaq = (id) => {
    setOpen(false)
    setSelectedId(id);
    handleLogModalOpen();
  }

  return (
    <>
      <Helmet>
        <title> Manage  SLA | ABEPL </title>
      </Helmet>
      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h4" gutterBottom>
            Manage SLA
          </Typography>
          <Button component={RouterLink} to='ManageSLAedit' variant="contained" startIcon={<AddIcon />}>
            Add
          </Button>
        </Stack>
        <Card>

          <Box sx={{ height: 400, width: 1 }}>

            <DataGrid
              rows={(userdetails[2] === HELPDESK_ROLES?.ExternalAdminUser || userdetails[2] === HELPDESK_ROLES?.ExternalSupportExecutive) ? extrows : rows}
              columns={issueColumns}
              // rowHeight={100}
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector


              // onSelectionModelChange={(newSelectionModel) => {
              //   // console.log("KKK", newSelectionModel);
              //   // setSelectionModel(newSelectionModel);
              // }}
              // selectionModel={selectionModel}

              disableSelectionOnClick
              // components={{ Toolbar: CustomToolbar }}
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>

        </Card>
        <ConfirmationPopover onOpen={logModalOpen} onConfirm={onConfirmDelete} action="Delete" onClose={handleLogModalClose} />

      </Container>
      {/* } */}
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem >
          <Button variant="text" startIcon={<Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />}>
            Edit
          </Button>
        </MenuItem>
        <MenuItem sx={{ color: 'error.main' }}>

          <Button variant="text" startIcon={<DeleteIcon />}
            onClick={(e) => deletefaq(openId)} color="error">
            Remove
          </Button>

        </MenuItem>
      </Popover>
    </>
  )
}

export default ManageCategoryPage